import React, { useCallback, useEffect, useRef, useState } from "react";
import { Sparkles, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, API, formatApiError } from "@/lib/api";

const DEFAULT_LOGO =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_arena-dubal/artifacts/dgj3odz1_Logo%20Dubal%20branca.png";

export default function LogoManager() {
  const [settings, setSettings] = useState({ logo_image: false, logo_image_updated_at: "" });
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/settings");
      setSettings(res.data);
    } catch (e) {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      await api.post("/admin/logo-image", fd);
      toast.success("Logo atualizada!");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  const preview = settings.logo_image
    ? `${API}/settings/logo-image?v=${encodeURIComponent(settings.logo_image_updated_at)}`
    : DEFAULT_LOGO;

  return (
    <div className="mt-8" data-testid="logo-manager">
      <div className="flex items-center gap-2">
        <Sparkles className="h-5 w-5 text-[#1B7A45]" />
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">
          Logo do topo
        </h2>
      </div>
      <p className="mt-1 text-sm text-slate-500">
        Substitua a logo exibida no topo do site. Use PNG com fundo transparente para melhor
        resultado.
      </p>

      <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-4">
        <div className="flex items-center justify-center rounded-xl bg-[#122018] p-6">
          <img src={preview} alt="Prévia da logo" className="max-h-24 w-auto max-w-full object-contain" />
        </div>
        <p className="mt-2 text-center text-xs text-slate-400">
          {settings.logo_image ? "Logo personalizada" : "Logo padrão"}
        </p>

        <input
          ref={fileRef}
          type="file"
          accept="image/png,image/jpeg,image/webp,image/gif"
          onChange={onFile}
          className="hidden"
          data-testid="logo-file-input"
        />
        <Button
          data-testid="logo-upload-btn"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="mt-3 w-full rounded-xl bg-[#1B7A45] py-5 font-semibold text-white hover:bg-[#156337] disabled:opacity-50"
        >
          <Upload className="mr-2 h-4 w-4" />
          {uploading ? "Enviando..." : "Trocar logo"}
        </Button>
      </div>
    </div>
  );
}
